import axios from "axios";

// Используем относительные пути — запросы идут на текущий домен и проксируются nginx-ом на backend:8001.
// Это убирает зависимость от REACT_APP_BACKEND_URL во время сборки и предотвращает «зашивание» левого домена в бандл.
const API_PREFIX = "/api";

export function resolveImg(url) {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    // Относительный URL отдаётся как есть — браузер возьмёт текущий origin.
    return url;
}

const api = axios.create({
    baseURL: API_PREFIX,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = localStorage.getItem("refresh_token");
            if (refreshToken) {
                try {
                    const res = await axios.post(`${API_PREFIX}/auth/refresh`, {
                        refresh_token: refreshToken,
                    });
                    localStorage.setItem("access_token", res.data.access_token);
                    originalRequest.headers.Authorization = `Bearer ${res.data.access_token}`;
                    return api(originalRequest);
                } catch (e) {
                    localStorage.removeItem("access_token");
                    localStorage.removeItem("refresh_token");
                }
            }
        }
        return Promise.reject(error);
    }
);

// BACKEND_URL экспортируется пустым для обратной совместимости (используется в AdminPanel
// для построения absolute-ссылок на загруженные файлы — теперь они тоже относительные).
const BACKEND_URL = "";

export default api;
export { BACKEND_URL };
